require("babel-polyfill");

try {
  window.$ = window.jQuery = require("jquery");
  require("bootstrap");
} catch (e) {
  console.error(e);
}

const API_KEY = document.head.querySelector('meta[name="api-key"]');
const CSRF_TOKEN = document.head.querySelector('meta[name="csrf-token"]');

window.axios = require("axios");

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (API_KEY) {
  window.axios.defaults.headers.common[
    "X-Authorization"
  ] = `${API_KEY.content}`;
} else {
  console.error("Missing API key");
}

if (CSRF_TOKEN) {
  window.axios.defaults.headers.common[
    "X-CSRF-TOKEN"
  ] = `${CSRF_TOKEN.content}`;
} else {
  console.error("Missing CSRF token");
}
